module.exports = __webpack_public_path__ + "static/media/4.21b9bf53.png";